import { render } from "./visualizarCabecario.vue?vue&type=template&id=075e68a7"
import script from "./visualizarCabecario.vue?vue&type=script&lang=js"
export * from "./visualizarCabecario.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__